import React, {useState} from 'react';
import * as Yup from 'yup';

import ModalTemplate from '../../../components/modal';
import {
  AppForm,
  AppFormField,
  AppFormSubmitButton,
} from '../../../components/forms';
import './styles.scss';
import {strings} from '../../../util/strings';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {Row} from '../../../components/layout';
import Icon from '../../../components/icon';
import {Icons} from '../../../util/icons';
import colors from '../../../util/colors';
import {patch} from '../../../api/api';
import {uriChangePassword} from '../../../api/endpoints';
import * as fonts from '../../../util/fonts';
import {Link, useHistory} from 'react-router-dom';
import NewErrorMessage from '../../../components/new-error-message';

interface ValidateContactProps {
  showModal: boolean;
  setShowModal(value: boolean): void;
  fieldEdited: number;
  setFieldEdited(field: number): void;
  sendCode(value: any, fieldEdited: number, isResend?: boolean): void;
  submit(value: any, fieldEdited: number): void;
  sendingNewCode: boolean;
  setSendingNewCode(value: boolean): void;
  setShowWrongCodeError(value: boolean): void;
  setShowSubmitCodeError(value: boolean): void;
  valueChanged: string;
  globalStyles: any;
  showResendConfirmation: boolean;
  labels: typeof strings.pt.myData;
  loginLabels: typeof strings.pt.login;
  messageLabels: typeof strings.pt.messages;
  servicesLabels?: typeof strings.pt.services;
  user: any;
  showWrongCodeError: boolean;
  showSubmitCodeError: boolean;
  showCodeResendError: boolean;
  codeErrorMsg: string;
}

function ValidateContactModal({
  showModal,
  setShowModal,
  submit,
  valueChanged,
  labels = strings.pt.myData,
  messageLabels = strings.pt.messages,
  loginLabels = strings.pt.login,
  servicesLabels = strings.pt.services,
  fieldEdited,
  globalStyles,
  showResendConfirmation,
  showWrongCodeError,
  showSubmitCodeError,
  setFieldEdited,
  sendCode,
  sendingNewCode,
  setSendingNewCode,
  setShowWrongCodeError,
  setShowSubmitCodeError,
  showCodeResendError,
  codeErrorMsg,

  user,
}: ValidateContactProps) {
  const [success, setSuccess] = useState(false);
  const [formikContext, setFormikContext] = useState<any>();

  const history = useHistory();

  const validationSchema = Yup.object().shape({
    code: Yup.string().required(messageLabels?.requiredField),
  });

  return (
    <div className="change-password-modal-content">
      <ModalTemplate
        show={showModal}
        onHide={() => {
          setShowModal(false);
          setShowWrongCodeError(false);
          setShowSubmitCodeError(false);
        }}
        cross={true}
        hideFooter={true}
        className="card-details-modal">
        <AppForm
          className="change-password-modal-form-container"
          initialValues={{
            code: '',
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => submit(values.code, fieldEdited)}>
          <Row style={{fontSize: '24px', fontWeight: 'bolder', marginTop: 0}}>
            {labels?.myData_validateContact_title}
          </Row>

          <div className="change-password-container">
            <Row style={{...fonts.M}}>
              {fieldEdited === 2
                ? labels?.myData_validateContact_subtitleEmail
                : labels?.myData_validateContact_subtitle}
            </Row>
            <Row style={{...fonts.M}}>
              {`${labels?.myData_validateContact_subtitle_sufix} ${valueChanged}`}
            </Row>
            <Row className="account-data-row">
              <AppFormField
                name="code"
                placeholder={labels?.myData_validateContact_codePlaceholder}
                handleFormikContext={(formik) => {
                  if (
                    !!!formikContext ||
                    formik.errors !== (formikContext as any).errors
                  ) {
                    setFormikContext(formik);
                  }
                }}
                showErrorMessage
              />
            </Row>
            {showResendConfirmation && (
              <div className="app-center enter-code-resend-code-message">
                <span
                  style={{...fonts.M}}
                  className="enter-code-header">{`${labels?.myData_validateContact_codeSent}`}</span>
              </div>
            )}
            <Row className="app-center enter-code-resend-code">
              <Link
                className={
                  sendingNewCode
                    ? 'activate-registration-anchors-disable'
                    : 'activate-registration-anchors'
                }
                style={{
                  color: globalStyles?.primaryColor,
                  ...fonts.SemiBold,
                }}
                to={history.location.pathname + history.location.search}
                onClick={async () => {
                  if (!sendingNewCode) {
                    sendCode(valueChanged, fieldEdited, true);
                    formikContext?.setFieldValue('code', '', false);
                  }
                }}>
                {labels?.myData_validateContact_sendNewCode}
              </Link>
            </Row>
            {showWrongCodeError && (
              <NewErrorMessage
                iconName={Icons.ALERT_PROBLEM}
                colorIcon={colors.alertRed}
                text={
                  labels?.myData_validateContact_wrongCode
                }></NewErrorMessage>
            )}
            {showSubmitCodeError && (
              <NewErrorMessage
                iconName={Icons.ALERT_PROBLEM}
                colorIcon={colors.alertRed}
                text={messageLabels?.general_errorMessage}></NewErrorMessage>
            )}
            {showCodeResendError && (
              <NewErrorMessage
                iconName={Icons.ALERT_PROBLEM}
                colorIcon={colors.alertRed}
                text={codeErrorMsg}></NewErrorMessage>
            )}
            <Row>
              <AppFormSubmitButton
                title={labels?.myData_validateContact_buttonText}
                className="stepper-continue-button change-password-submit-button"
              />
            </Row>
          </div>
        </AppForm>
      </ModalTemplate>
    </div>
  );
}

const mapStateToProps = ({strings, user, globalStyles}: any) => ({
  labels: strings.value.pt.myData,
  messageLabels: strings.value.pt.messages,
  loginLabels: strings.value.pt.login,
  servicesLabels: strings.value.pt.services,
  user: user.value,
  globalStyles: globalStyles.value,
});

export default compose(connect(mapStateToProps)(ValidateContactModal));
